import { Component, OnInit } from '@angular/core';
// import { ActivatedRoute, Params } from '@angular/router';

@Component({
  selector: 'app-products-sidebar',
  templateUrl: './products-sidebar.component.html',
  styleUrls: ['./products-sidebar.component.scss']
})
export class ProductsSidebarComponent implements OnInit {

  constructor(
    // private route:ActivatedRoute 
  ) { }

  ngOnInit() {
    // this.route.params.subscribe((params: Params) => {
    //   console.log('products-sidebar: params', params);
    //   console.log('products-sidebar: params.category:', params["category"]);
    // });
  }

}



// WEBPACK FOOTER //
// ./src/app/components/products/products-sidebar/products-sidebar.component.ts